import { useQuery as o } from "@tanstack/react-query";
import { customInstance as y } from "../../mutator/custom-instance.es.js";
const q = (e, t, n, r) => y({
  url: `/api/experiences/${e}/time-slots/${t}`,
  method: "GET",
  signal: r
}, n), p = (e, t) => [`/api/experiences/${e}/time-slots/${t}`], l = (e, t, n) => {
  const {
    query: r,
    request: s
  } = n ?? {};
  return {
    queryKey: (r == null ? void 0 : r.queryKey) ?? p(e, t),
    queryFn: ({
      signal: u
    }) => q(e, t, s, u),
    enabled: !!(e && t),
    ...r
  };
};
function a(e, t, n) {
  const r = l(e, t, n), s = o(r);
  return s.queryKey = r.queryKey, s;
}
const m = (e, t, n, r) => y({
  url: `/api/experiences/${e}/time-slots`,
  method: "GET",
  params: t,
  signal: r
}, n), K = (e, t) => [`/api/experiences/${e}/time-slots`, ...t ? [t] : []], E = (e, t, n) => {
  const {
    query: r,
    request: s
  } = n ?? {};
  return {
    queryKey: (r == null ? void 0 : r.queryKey) ?? K(e, t),
    queryFn: ({
      signal: u
    }) => m(e, t, s, u),
    enabled: !!e,
    ...r
  };
};
function S(e, t, n) {
  const r = E(e, t, n), s = o(r);
  return s.queryKey = r.queryKey, s;
}
export {
  K as getListExperienceTimeSlotsQueryKey,
  E as getListExperienceTimeSlotsQueryOptions,
  p as getReadExperienceTimeSlotQueryKey,
  l as getReadExperienceTimeSlotQueryOptions,
  m as listExperienceTimeSlots,
  q as readExperienceTimeSlot,
  S as useListExperienceTimeSlots,
  a as useReadExperienceTimeSlot
};
